import { Grid, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { AddToolButton } from "source/components/framework/Button/AddToolButton";
import { RemoveToolButton } from "source/components/framework/Button/RemoveToolButton";
import { AppReportTaskTypeDocumentReference } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeDocumentReference";
import { DocumentSelectDialog } from "source/components/document/DocumentSelectDialog";
import { IFolderTreeNode } from "source/models/document/folderTreeNode";
import { DocumentFolders } from "source/models/document/documentFolders";

interface IFormDesignerComponentPropertiesDocRefProps {
    companyId: string;
    formFieldMargin: string;
    taskTypeCol?: ITaskTypeCol;
    onGetDocumentFoldersAndDocuments?: (companyId: string) => Promise<DocumentFolders>;
    onTaskTypePropUpdate?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

export const FormDesignerComponentPropertiesDocRef = (
    props: IFormDesignerComponentPropertiesDocRefProps
) => {
    const [showDocumentSelectDialog, setShowDocumentSelectDialog] = useState(false);

    const handleObjectValueChange = (obj) => {
        props.onTaskTypePropUpdate([{
            field: props.taskTypeCol?.field,
            name: "objectValue",
            value: obj
        }]);
    };

    const objectValue = new AppReportTaskTypeDocumentReference(props.taskTypeCol.objectValue);

    const handleDocumentSelect = async () => {
        setShowDocumentSelectDialog(true);
    };

    const handleDocumentSelectDialogOk = (folderTreeNode: IFolderTreeNode, documentFullPath: string) => {
        objectValue.documentPath = documentFullPath;
        objectValue.documentName = folderTreeNode.name;
        objectValue.documentId = folderTreeNode.id;
        handleObjectValueChange(objectValue);
        setShowDocumentSelectDialog(false);
    };

    const handleDocumentRemove = async () => {
        objectValue.documentName = "";
        objectValue.documentId = "";
        handleObjectValueChange(objectValue);
    };

    return (
        <>
            <Grid item sm={12}>
                <FormField title={Translations.Document} margin={props.formFieldMargin}>
                    <TextField
                        value={objectValue.documentName}
                        sx={
                            {
                                ".MuiInputBase-root": {
                                    paddingRight: 0
                                }
                            }
                        }
                        InputProps={{
                            inputProps: { readOnly: true, disabled: true },
                            endAdornment:
                                <InputAdornment position="end">
                                    <AddToolButton
                                        tooltip={Translations.SelectDocument}
                                        onClick={handleDocumentSelect}
                                    />
                                    <RemoveToolButton
                                        disabled={!objectValue.documentId}
                                        tooltip={Translations.RemoveDocument}
                                        onClick={handleDocumentRemove}
                                    />
                                </InputAdornment>
                        }}
                    />
                </FormField>
            </Grid>
            {!!objectValue.documentId &&
                <Grid item sm={12}>
                    <FormField title={Translations.Path} margin={props.formFieldMargin}>
                        {objectValue.documentPath}
                    </FormField>
                </Grid>
            }
            {showDocumentSelectDialog &&
                <DocumentSelectDialog
                    companyId={props.companyId}
                    onGetDocumentFoldersAndDocuments={props.onGetDocumentFoldersAndDocuments}
                    onOk={handleDocumentSelectDialogOk}
                    onCancel={() => setShowDocumentSelectDialog(false)}
                />
            }
        </>
    );
};
